module.exports = __webpack_public_path__ + "static/media/bee_colony.9e4267b3.jpg";